import { useCallback } from 'react'
import type { ReportBucketType } from '@services/api/reports/finance.api'
import {
  getScheduledAppointmentsReport,
  type ScheduledAppointmentsReportResult,
} from '@services/api/reports/operations.api'
import { useFinanceReportQuery } from '@hooks/reports/useFinanceReportQuery'

export type ScheduledAppointmentsReportData = ScheduledAppointmentsReportResult

export type UseScheduledAppointmentsReportResult = {
  loading: boolean
  error: string | null
  data: ScheduledAppointmentsReportData | null
  bucketLabel: string
}

export function useScheduledAppointmentsReport(
  toolbarSelection: Record<string, string>,
): UseScheduledAppointmentsReportResult {
  const getBucketFromData = useCallback(
    (data: ScheduledAppointmentsReportResult): ReportBucketType =>
      data.patientsSeen.bucket,
    [],
  )

  return useFinanceReportQuery({
    toolbarSelection,
    fetchReport: getScheduledAppointmentsReport,
    getBucketFromData,
    errorMessage: 'Failed to load scheduled appointments data',
  })
}
